// extracted by mini-css-extract-plugin
module.exports = {"opEdBanner":"style_opEdBanner__1jjmQ"};